{
  "layout": {
    "title": "Marché",
    "intro": "Achète, vends, enchéris et échange des personnages contre de l’Anima.",
    "tabs": "Sections du marché",
    "sales": "Ventes",
    "auctions": "Enchères",
    "myListings": "Mes ventes",
    "myAuctions": "Mes enchères",
    "history": "Historique",
    "trades": "Échanges"
  },
  "openCollection": "Ouvrir ma collection",
  "sorts": {
    "recent": "Plus récentes",
    "price_asc": "Prix croissant",
    "price_desc": "Prix décroissant",
    "auction_ending": "Fin la plus proche",
    "auction_price": "Prix actuel croissant",
    "attack_desc": "Attaque (forte → faible)",
    "attack_asc": "Attaque (faible → forte)",
    "defense_desc": "Défense (forte → faible)",
    "defense_asc": "Défense (faible → forte)",
    "auction_attack_desc": "Attaque (forte → faible)",
    "auction_attack_asc": "Attaque (faible → forte)",
    "auction_defense_desc": "Défense (forte → faible)",
    "auction_defense_asc": "Défense (faible → forte)"
  },
  "listingStatus": {
    "active": "En vente",
    "sold": "Vendue",
    "cancelled": "Retirée",
    "expired": "Expirée"
  },
  "filters": {
    "button": "Filtres",
    "title": "Affiner le marché",
    "reset": "Réinitialiser",
    "results": "Afficher les résultats",
    "search": "Rechercher un personnage ou un titre",
    "rarity": "Filtrer par rareté",
    "all": "Toutes les raretés",
    "sort": "Trier"
  },
  "empty": {
    "listings": "Aucune annonce",
    "listingsRarity": "Aucune annonce active dans cette rareté.",
    "listingsSearch": "Aucune annonce ne correspond à cette recherche.",
    "listingsHint": "Mets une carte en vente depuis sa fiche, dans ta collection.",
    "auctions": "Aucune enchère en cours",
    "auctionsHint": "Lance une enchère depuis la fiche d’une carte, dans ta collection.",
    "auctionsSearch": "Aucune enchère ne correspond à cette recherche.",
    "auctionsRarity": "Aucune enchère en cours dans cette rareté.",
    "myAuctions": "Aucune enchère",
    "history": "Aucune transaction",
    "historyHint": "Tes achats, ventes et échanges conclus apparaîtront ici."
  },
  "buy": {
    "title": "Acheter {{name}}",
    "quoteBefore": "« ",
    "quoteAfter": " »",
    "seller": "Vendeur",
    "level": "Niveau de la carte",
    "price": "Prix",
    "after": "Solde après l’achat",
    "duplicate": "Si tu possèdes déjà ce personnage, la carte reçue est convertie en fragments.",
    "short": "Il te manque {{amount}} Anima.",
    "success": "Achat réussi",
    "failed": "Achat impossible",
    "action": "Acheter"
  },
  "bids": {
    "none": "Aucune mise",
    "count_one": "{{count}} mise",
    "count_other": "{{count}} mises"
  },
  "mine": {
    "withdrawn": "Annonce retirée",
    "withdrawFailed": "Retrait impossible",
    "withdraw": "Retirer"
  },
  "history": {
    "player": "un joueur",
    "listingSale": "Vente à {{peer}}",
    "auctionSale": "Enchère remportée par {{peer}}",
    "listingBuy": "Achat à {{peer}}",
    "auctionBuy": "Enchère gagnée face à {{peer}}",
    "trade": "Échange avec {{peer}}",
    "characters": "Personnages concernés",
    "level": "Niveau {{level}}",
    "given": "Donné",
    "received": "Reçu",
    "noAnima": "Sans Anima"
  },
  "myAuctions": {
    "cancelled": "Enchère annulée",
    "cancelFailed": "Annulation impossible"
  },
  "sell": {
    "title": "Vendre {{name}}",
    "kind": "Type de vente",
    "fixed": "Prix fixe",
    "auction": "Enchère",
    "system": "Système",
    "price": "Prix",
    "start": "Prix de départ",
    "range": "Entre {{min}} et {{max}} Anima.",
    "buyout": "Achat immédiat (optionnel)",
    "none": "Aucun",
    "buyoutHint": "Doit dépasser la mise de départ.",
    "duration": "Durée",
    "hours": "{{hours}} h",
    "value": "Valeur (niv. {{level}})",
    "buyback": "Reprise ({{percent}} %)",
    "jackpot": "Cagnotte ({{percent}} % de la reprise)",
    "receive": "Tu reçois",
    "fee": "Frais ({{percent}} %)",
    "net": "Tu recevras",
    "netLeast": "Tu recevras au moins",
    "systemHint": "Le système reprend la carte à {{percent}} % de sa valeur. Tu ne choisis pas le prix. {{pot}} % de cette somme partent dans la cagnotte de la Moisson d’Anima.",
    "feeHint": "Ces frais vont dans la cagnotte de la Moisson d’Anima. L’acheteur reçoit la carte au niveau {{level}}.",
    "fragments": "Tes {{amount}} fragments sont mis de côté et te reviendront si tu obtiens de nouveau ce personnage.",
    "tooCheap": "Cette carte ne vaut pas assez pour être reprise.",
    "locked": "Cette carte est déjà en vente ou en échange.",
    "toSystem": "Vendre au système",
    "list": "Mettre en vente",
    "launch": "Lancer l’enchère",
    "listed": "Annonce créée",
    "launched": "Enchère lancée",
    "listFailed": "Mise en vente impossible",
    "boughtTitle": "Carte reprise",
    "bought": "{{name}} · {{amount}} Anima"
  },
  "auction": {
    "back": "Enchères",
    "byBefore": "Mise en vente par",
    "cardLevel": "carte niveau {{level}}",
    "endsIn": "Fin dans",
    "ended": "Terminée",
    "closed": {
      "sold": "Vendue",
      "unsold": "Terminée sans acheteur",
      "cancelled": "Annulée"
    },
    "best": "Meilleure mise",
    "start": "Prix de départ",
    "min": "Mise minimale",
    "buyout": "Achat immédiat",
    "leader": "Meilleur enchérisseur",
    "nobody": "Personne",
    "seller": "C’est ta vente : tu ne peux pas enchérir dessus.",
    "yourBid": "Ta mise",
    "leading": "Tu es en tête. Tu pourras miser de nouveau si quelqu’un te dépasse.",
    "minHint": "Entre {{min}} et {{max}} Anima, réservés jusqu’à ce qu’on te dépasse.",
    "bid": "Enchérir",
    "bidOk": "Mise placée",
    "bidNo": "Mise refusée",
    "buyoutOk": "Achat immédiat réussi",
    "buyoutNo": "Achat immédiat impossible",
    "buy": "Acheter",
    "recent": "Dernières mises",
    "none": "Aucune mise pour l’instant.",
    "buyoutTag": " · achat immédiat"
  },
  "trades": {
    "aria": "Boîte des échanges",
    "incoming": "Reçus",
    "outgoing": "Envoyés",
    "history": "Historique",
    "emptyIncoming": "Aucune proposition reçue",
    "emptyOutgoing": "Aucune proposition envoyée",
    "emptyHistory": "Aucun échange terminé",
    "emptyHint": "Pour proposer un échange, ouvre le profil d’un joueur.",
    "pending": "En cours",
    "completed": "Conclu",
    "declined": "Refusé",
    "cancelled": "Annulé",
    "expired": "Expiré"
  },
  "cards_one": "{{count}} carte",
  "cards_other": "{{count}} cartes",
  "animaAmount": "{{amount}} Anima",
  "nothing": "rien",
  "row": {
    "summary": "Tu donnes {{give}} · tu reçois {{receive}}",
    "balanced": "équilibré",
    "gain": "+{{amount}} Anima de valeur",
    "loss": "−{{amount}} Anima de valeur",
    "obtained": "Obtenue",
    "notObtained": "Pas obtenue",
    "turn": "À répondre",
    "waiting": "En attente"
  },
  "side": {
    "youGive": "Tu donnes",
    "youReceive": "Tu reçois",
    "nothing": "Rien",
    "cards": "Cartes",
    "anima": "Anima",
    "total": "Total"
  },
  "value": {
    "even": "Échange équilibré en valeur de référence.",
    "gain": "Tu gagnes environ {{amount}} Anima de valeur.",
    "loss": "Tu perds environ {{amount}} Anima de valeur."
  },
  "detail": {
    "back": "Échanges",
    "title": "Échange avec @{{username}}",
    "closed": "{{status}} le {{date}}",
    "yourTurn": "À toi de répondre · expire dans {{time}}",
    "waiting": "En attente de @{{username}} · expire dans {{time}}",
    "fee": "Frais de {{percent}} % retenus sur l’Anima :",
    "done": "Échange conclu",
    "confirmFailed": "Confirmation impossible",
    "counter": "Contre-proposer",
    "declined": "Échange refusé",
    "declineFailed": "Refus impossible",
    "decline": "Refuser",
    "cancelled": "Échange annulé",
    "cancelFailed": "Annulation impossible",
    "cancel": "Annuler la proposition",
    "accept": "Accepter l’échange"
  },
  "youGive": "Tu donnes",
  "youReceive": "Tu reçois",
  "picker": {
    "search": "Rechercher",
    "add": "Ajouter une carte…",
    "filter": "Filtrer les cartes",
    "searchToAdd": "Recherche une carte pour l’ajouter à l’échange.",
    "noResults": "Aucun résultat pour cette recherche.",
    "total": "Total cartes",
    "sorts": {
      "recent": "Obtenus récemment",
      "popularity": "Popularité",
      "nametag": "Étiquette",
      "rarity": "Rareté",
      "fragments": "Fragments",
      "name": "Nom",
      "attack_desc": "Attaque (forte → faible)",
      "attack_asc": "Attaque (faible → forte)",
      "defense_desc": "Défense (forte → faible)",
      "defense_asc": "Défense (faible → forte)"
    }
  },
  "builder": {
    "trade": "Échange",
    "counter": "Contre-proposition",
    "offer": "Proposer un échange",
    "intro": "Avec @{{username}}. Tu peux proposer jusqu’à {{max}} cartes. L’Anima ne peut venir que d’un côté et {{fee}} % de frais sont retenus dessus, pour la cagnotte de la Moisson d’Anima.",
    "cardLimit": "Tu peux sélectionner au plus {{max}} cartes de ce côté.",
    "playerLimits": "Tes limites : {{mine}} cartes et {{mineAnima}} Anima. Limites du partenaire : {{theirs}} cartes et {{theirsAnima}} Anima.",
    "limitsExceeded": "Cette offre dépasse les limites actuelles de l’un des joueurs. Réduis les cartes ou l’Anima concernés.",
    "invalidAnima": "L’Anima doit être un nombre entier positif ou nul, sans décimales.",
    "ask": "Tu demandes",
    "emptyMine": "Aucune carte disponible : les cartes en vente ou en échange sont verrouillées.",
    "animaGive": "Anima offerte",
    "emptyTheirs": "@{{username}} n’a aucune carte disponible.",
    "animaAsk": "Anima demandée",
    "gap": "Écart",
    "even": "Équilibré",
    "note": "Message (optionnel)",
    "notePlaceholder": "Un mot pour accompagner ta proposition",
    "oneSide": "L’Anima ne peut venir que d’un seul côté.",
    "sendCounter": "Envoyer la contre-proposition",
    "send": "Proposer l’échange",
    "sentCounter": "Contre-proposition envoyée",
    "sent": "Proposition envoyée",
    "sendFailed": "Envoi impossible"
  }
}
